/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of quartz scheduling calendar, CRON or SIMPLE supported by quartz framework.
 */
export type QuartzScheduleType = 'CRON' | 'SIMPLE';

export const QuartzScheduleType = {

    CRON: 'CRON' as QuartzScheduleType,

    SIMPLE: 'SIMPLE' as QuartzScheduleType
};

